import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { DevelopmentService, Development } from '@app/_components/development';
import { AlertService, AuthenticationService } from '@app/_services';
import { Router } from '@angular/router';
import { Locations, ListingStatus } from '@app/_helpers/constants';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {TaskComponent} from '@app/_components/task/task/task.component';
import {PublicTaskListComponent} from '@app/_components/task/public-task-list/public-task-list.component';

@Component({
    selector: 'app-development-list',
    templateUrl: './development-list.component.html',
    styleUrls: ['./development-list.component.css'],
    standalone: false
})
export class DevelopmentListComponent implements OnInit
{
	datasource: Development[];
	development: Development;
	developments: Development[] = [];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	userStatusOptions: SelectItem[];


	constructor(
		private authenticationService: AuthenticationService,
		private developmentService: DevelopmentService,
		private alertService: AlertService,
		private router: Router,
    private dialog: MatDialog
	) { }

	listingStatuses = [
		{ value: 0, name: 'Active' },
		{ value: 2, name: 'Suspended' },
		{ value: 1, name: 'Archived' }
	];


	ngOnInit()
	{
	}

	loadLazy(event: LazyLoadEvent)
	{
		try
		{
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.developmentService.findAgentListByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					data =>
					{
						console.log('developments are: ' + JSON.stringify(data));
						this.datasource = data.data.developments;
						this.recordTotal = data.page.recordTotal;
						this.developments = data.data.developments;
					},
					error =>
					{
						console.log('USER LIST!: ' + JSON.stringify(error));
						this.alertService.error(error);
					},
					() =>
					{ this.loading = false; }
				);

			if (this.datasource)
			{
				this.developments = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error)
		{
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event)
	{
		try
		{
			this.loading = true;
			// console.log('onRowSelect(' + JSON.stringify(event) + ')');
			// use this for adding query params
			// this.router.navigate(['user-edit'], { queryParams: { userId: event.data.userId } });
			this.router.navigate(['development-edit', event.data.developmentId]);
		} catch (error)
		{
			console.log('onRowSelect(' + event + ')' + error);
		}
	}
	reloadPage() {
		window.location.reload();
	}

  openPublicTaskList() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Tasks',
      taskSource: 130,  // TaskSourceEnum.DEVELOPMENT — was 7 (ONBOARDING), wrong
      showFilter: true
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(PublicTaskListComponent, dialogConfig);

  }

  get ListingStatus() {
		return ListingStatus;
	}
}
